const useGetApiData = () => {
 
  const getApiData = (pathNames, apiData, index = 0) => {
    
    if(apiData) {
      //let pathNames =  pathName.split(".")
      //pathNames = pathNames.slice(1, pathNames.length)      
      return getValue(apiData, pathNames, index) 
    } else {
      return "" //"$Not Found$"
    }
  }

  const getValue = (data, pathNames, index) => {
    
    //if (!data || pathNames.length == 0 || typeof data != "object" ||  Array.isArray(data)) 
    if (!data) return ""
      
    if (pathNames.length == 0) return data
    
    return getValue( Array.isArray(data) ? data[index][pathNames[0]]: data[pathNames[0]]
      , pathNames.slice(1, pathNames.length), index)
  }

  return getApiData;
};

export default useGetApiData;
